/** Matches backend: only carbon bucket seats count for inventory. */
export function hasCarbonBucketSeats(car: { Options?: string[] }): boolean {
  return (car.Options ?? []).some((option) => option === 'M Carbon Bucket Seats')
}

export function hasCompetitionPackage(car: { Year?: number; Options?: string[] }): boolean {
  if ((car.Year ?? 9999) > 2020) {
    return false
  }
  return (car.Options ?? []).some((option) => option === 'Competition Package')
}

/** Matches backend ShowsInInventory: carbon bucket seats only. */
export function showsInInventory(car: { Year?: number; Options?: string[] }): boolean {
  return hasCarbonBucketSeats(car)
}

export function getInventoryBadgeText(car: { Year?: number; Options?: string[] }): string {
  if (hasCarbonBucketSeats(car)) {
    return 'Carbon Buckets'
  }
  if (hasCompetitionPackage(car)) {
    return 'Competition Package'
  }
  return ''
}
